import i18 from "i18next";

export const makeUrl = (shortUrl: string): string =>
  `/${i18.language}/${shortUrl.startsWith("/") ? shortUrl.slice(1) : shortUrl}`;
